import React from 'react'
import { Form } from 'antd'
import { Trans } from '@lingui/react/macro'

import Step0 from './Step0'
import Step2 from './Step2'

import { useSignUpSteps } from '@/contexts/AuthContext/hooks/signUpSteps'
import { CssIcon } from '@/components/CssIcon'


import { useEffect, useMemo } from 'react';
import { cls } from 'tagged-classnames-free';
export interface ISignUpFormValues {
  firstName: string
  lastName: string
  code: string
  email: string
  password: string
}

export interface ISignUpByEmailProps {
  className?: string
  onSignUpSuccess?: (() => void) | undefined
  onChangeStep?: (step: number) => void
  handleClickLogIn?: () => void
  titleAs?: React.ElementType
  formContainerClassName?: string
  readOnlyEmail?: string
  onChangeSignUpByEmail: (value: boolean) => void
}

export interface ISignUpStepProps {
  onNext?: () => Promise<void>
  handleCreate: () => Promise<void>
  handleVerify: () => Promise<void>
  countdownSendCode?: number
  loading?: boolean
  sendEmailVerifiedCode?: (flag?: boolean) => Promise<void>
  handleBack?: () => void
  handleClickLogIn?: () => void
  titleAs?: React.ElementType
  formContainerClassName?: string
  readOnlyEmail?: string
  isLoadingSendEmailVerifiedCode?: boolean
}

const steps = [Step0, Step2]

const SignUpByEmail: React.FC<ISignUpByEmailProps> = (props) => {
  const {
    onChangeStep,
    onSignUpSuccess,
    handleClickLogIn,
    titleAs,
    formContainerClassName,
    readOnlyEmail,
    onChangeSignUpByEmail,
  } = props

  const {
    loading,
    step,
    countdownSendCode,
    sendEmailVerifiedCode,
    handleNext,
    handleBack,
    form,
    backable,
    handleCreate,
    handleVerify,
    isLoadingSendEmailVerifiedCode,
  } = useSignUpSteps({
    onSignUpSuccess,
    onChangeSignUpByEmail,
  })

  useEffect(() => {
    if (onChangeStep) {
      onChangeStep(step)
    }
  }, [onChangeStep, step])

  const content = useMemo(() => {
    const StepComponent = steps[step]

    return (
      <StepComponent
        handleCreate={handleCreate}
        handleVerify={handleVerify}
        readOnlyEmail={readOnlyEmail}
        titleAs={titleAs}
        onNext={handleNext}
        countdownSendCode={countdownSendCode}
        loading={loading}
        sendEmailVerifiedCode={sendEmailVerifiedCode}
        handleBack={handleBack}
        handleClickLogIn={handleClickLogIn}
        formContainerClassName={formContainerClassName}
        isLoadingSendEmailVerifiedCode={isLoadingSendEmailVerifiedCode}
      />
    )
  }, [
    step,
    handleCreate,
    handleVerify,
    readOnlyEmail,
    titleAs,
    handleNext,
    countdownSendCode,
    loading,
    sendEmailVerifiedCode,
    handleBack,
    handleClickLogIn,
    formContainerClassName,
    isLoadingSendEmailVerifiedCode,
  ])

  return (
    <Form<ISignUpFormValues>
      initialValues={{
        email: readOnlyEmail || '',
      }}
      form={form}
      layout='vertical'
      className='relative flex-1'
      requiredMark={false}
      labelAlign='left'
    >
      {backable && (
        <button
          type='button'
          className={cls`
            text-f-text-secondary hover:text-f-primary border-f-border
            absolute left-3 top-3
            flex  items-center
            justify-center rounded-[20px] border px-3 py-[6px] text-sm
          `}
          onClick={handleBack}
        >
          <CssIcon className='i-com--back-fill size-4' />
          <Trans>Back</Trans>
        </button>
      )}
      {content}
    </Form>
  )
}

export default SignUpByEmail
